import moment from 'moment';
import { StoreState } from '../store-interfaces';

export const selectMyLeadsSearchOptions = (state: StoreState) =>
  state.myLeads.searchOptions;

export const selectMyLeadsContacts = (
  state: StoreState,
  skipDummyContacts?: boolean,
) => {
  const currentSession = state.session.session;
  const companies = state.company.entities;
  const facebookPage = state.connectedPage.pageDetails;
  const activeCompany = companies.find(c => c.id === facebookPage?.companyId);

  const dummyContacts = [
    {
      id: -1,
      firstName: currentSession.firstName,
      lastName: currentSession.lastName,
      fullName: `${currentSession.firstName} ${currentSession.lastName}`,
      type: ['New'],
      email: currentSession.email,
      phone: activeCompany?.phoneNumber,
      createdAt: moment(currentSession.createdAt)
        .utc()
        .format('YYYY-MM-DD HH:mm:ss [UTC]'),
      source: 'X-Ray',
      businessContact: false,
      remoteId: `em_${currentSession.email}_0000`,
      deliverable: true,
      dummy: true,
    },
    {
      id: -2,
      firstName: 'Larry',
      lastName: 'Kim',
      fullName: 'Larry Kim',
      email: 'larrykim@customers.ai',
      type: ['Re-signaled'],
      phone: '+18001458796',
      createdAt: moment().utc().format('YYYY-MM-DD HH:mm:ss [UTC]'),
      source: 'X-Ray',
      businessContact: false,
      remoteId: 'em_larry|2kim@gmail|2ecom_0000',
      deliverable: true,
      dummy: true,
    },
  ];
  return state.myLeads.contacts.length || skipDummyContacts
    ? state.myLeads.contacts
    : dummyContacts;
};

export const selectMyLeadsPagination = (state: StoreState) =>
  state.myLeads.pagination;
